import { useFiltersStore } from '@/lib/filtersStore';
import { haptic } from '@/lib/telegram';
import type { AuctionSort } from '@/types/domain';
import clsx from 'clsx';
import styles from './SortSheet.module.css';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const SORT_OPTIONS: { value: AuctionSort; label: string; hint: string }[] = [
  { value: 'ending_soon', label: 'Скоро закончатся', hint: 'Меньше времени → выше' },
  { value: 'newest', label: 'Сначала новые', hint: 'Только что опубликованные' },
  { value: 'price_asc', label: 'Дешевле', hint: 'Цена по возрастанию' },
  { value: 'price_desc', label: 'Дороже', hint: 'Цена по убыванию' },
  { value: 'bids_count', label: 'Больше ставок', hint: 'Самые активные торги' },
  { value: 'popular', label: 'Популярные', hint: 'Ставки + просмотры' },
];

export const SortSheet = ({ isOpen, onClose }: Props) => {
  const sort = useFiltersStore((s) => s.sort);
  const setSort = useFiltersStore((s) => s.setSort);

  const handleSelect = (v: AuctionSort) => {
    haptic.light();
    setSort(v);
    onClose();
  };

  return (
    <div className={clsx(styles.overlay, isOpen && styles.overlayOpen)} onClick={onClose}>
      <div className={clsx(styles.sheet, isOpen && styles.sheetOpen)} onClick={(e) => e.stopPropagation()}>
        <div className={styles.handle} />
        <p className={styles.title}>Сортировка</p>

        <div className={styles.list}>
          {SORT_OPTIONS.map((opt) => {
            const isActive = opt.value === sort;
            return (
              <button
                key={opt.value}
                onClick={() => handleSelect(opt.value)}
                className={clsx(styles.option, isActive && styles.optionActive)}
              >
                <div className={styles.optionMain}>
                  <span className={styles.optionLabel}>{opt.label}</span>
                  <span className={styles.optionHint}>{opt.hint}</span>
                </div>
                {isActive && (
                  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="m5 12 5 5L20 7" />
                  </svg>
                )}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};